import ArrowRightSvg from '../../../assets/arrow-right.svg?react';
import { IconProps } from '../../types/IconProps';

export function ArrowRight({ size = 20, ...props }: IconProps) {
  return <ArrowRightSvg data-testid="arrow-right-icon" width={size} height={size} {...props} />;
}

export default ArrowRight;
